import { render, staticRenderFns } from "./ListaTopoPeriodo.vue?vue&type=template&id=5b1cdf94"
import script from "./ListaTopoPeriodo.vue?vue&type=script&lang=js"
export * from "./ListaTopoPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports